import React from 'react';
import Navbar from './Navbar';

export default function TermsPage() {
  return (
    <>
      <Navbar />
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '60px 24px' }}>
        <div className="badge badge-accent" style={{ marginBottom: 16 }}>Legal</div>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 'clamp(28px,5vw,48px)', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: 8 }}>Terms of Service</h1>
        <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 24, fontFamily: 'var(--mono)' }}>Effective date: April 10, 2026 · TrustTech Mobile</p>

        {/* Important warning box */}
        <div style={{ background: 'rgba(255,77,46,0.06)', border: '1px solid rgba(255,77,46,0.2)', borderRadius: 12, padding: '20px 24px', marginBottom: 40 }}>
          <p style={{ fontWeight: 700, fontSize: 14, color: '#FF4D2E', marginBottom: 8 }}>⚠️ Important — Please Read Section 3 Carefully</p>
          <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7 }}>SafeSnap is a technical tool only. It does not provide legal advice and makes no guarantee that verification results are legally admissible in any court or jurisdiction. Always consult a qualified lawyer for legal matters.</p>
        </div>

        {[
          {
            title: '1. Acceptance of Terms',
            body: 'By downloading, installing or using SafeSnap, you agree to be bound by these Terms of Service. If you do not agree, do not use the app. These Terms constitute a legally binding agreement between you and TrustTech Mobile.'
          },
          {
            title: '2. Description of Service',
            body: 'SafeSnap is a mobile application that creates tamper-evident photo records using GPS coordinates, timestamps and SHA-256 cryptographic hashing. The app is designed to help users document the condition of items, properties and situations at a specific point in time.'
          },
          {
            title: '3. No Legal Guarantee — IMPORTANT',
            highlight: true,
            body: 'SafeSnap does not provide legal advice. TrustTech Mobile makes no representation, warranty or guarantee that SafeSnap verification results are legally admissible as evidence in any court, tribunal or legal proceeding in any jurisdiction. SafeSnap proof records may not be accepted by any insurance company, government body, arbitrator or third party. Do not rely solely on SafeSnap output for legal matters. Consult a qualified lawyer in your jurisdiction for any legal dispute.'
          },
          {
            title: '4. Limitation of Liability',
            body: 'To the maximum extent permitted by applicable law, TrustTech Mobile shall not be liable for any direct, indirect, incidental, special, consequential or punitive damages arising from your use of SafeSnap, including loss of money, loss in any dispute, failure of results to be accepted by any party, or any reliance on SafeSnap output. Our total liability shall not exceed the amount you paid in the 12 months preceding any claim.'
          },
          {
            title: '5. Disclaimer of Warranties',
            body: 'SafeSnap is provided "as is" and "as available" without any warranty of any kind, express or implied, including warranties of merchantability, fitness for a particular purpose, or that the app will be uninterrupted, error-free or that verification results are accurate, complete or reliable.'
          },
          {
            title: '6. User Responsibilities',
            body: 'You are solely responsible for how you use the app and its output. You will not use SafeSnap for any unlawful, fraudulent or deceptive purpose. You will not attempt to manipulate or falsify SafeSnap proof records. You understand SafeSnap is a supporting tool and not a substitute for professional legal advice.'
          },
          {
            title: '7. Acceptable Use',
            body: 'You may use SafeSnap only for lawful documentation purposes including property condition, item condition, service completion and insurance documentation. You may NOT use SafeSnap to create false or misleading proof records, impersonate any person, or violate any applicable law.'
          },
          {
            title: '8. Subscriptions and Payments',
            body: 'Paid plans are billed through Google Play and auto-renew unless cancelled 24 hours before renewal. Refunds are subject to Google Play\'s refund policy. We reserve the right to change prices with reasonable notice. The free plan is limited to 5 proof records per month.'
          },
          {
            title: '9. Intellectual Property',
            body: 'SafeSnap, including its design, code, graphics and content, is the intellectual property of TrustTech Mobile. You may not copy, modify, distribute or reverse engineer any part of the app without written permission.'
          },
          {
            title: '10. Termination',
            body: 'We reserve the right to suspend or terminate your access to SafeSnap at any time for violation of these Terms. You may stop using the app at any time.'
          },
          {
            title: '11. Governing Law',
            body: 'These Terms are governed by the laws of the Province of Ontario, Canada. Any disputes shall be resolved in the courts of Ontario, Canada.'
          },
          {
            title: '12. Changes to These Terms',
            body: 'We may update these Terms from time to time. Continued use of the app after changes constitutes acceptance of the updated Terms.'
          },
          {
            title: '13. Contact',
            body: 'TrustTech Mobile · safesnap.app@gmail.com · https://safesnap-aa25e.web.app'
          },
        ].map((section, i) => (
          <div key={i} style={{
            marginBottom: 36, paddingBottom: 36,
            borderBottom: i < 12 ? '0.5px solid rgba(10,10,15,0.08)' : 'none',
            background: section.highlight ? 'rgba(255,77,46,0.03)' : 'transparent',
            borderRadius: section.highlight ? 8 : 0,
            padding: section.highlight ? '16px' : '0',
          }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10, color: section.highlight ? '#FF4D2E' : 'var(--ink)' }}>{section.title}</h2>
            <p style={{ fontSize: 15, color: 'var(--muted)', lineHeight: 1.8 }}>{section.body}</p>
          </div>
        ))}
      </div>
      <footer><div className="footer-inner"><div className="footer-brand">SafeSnap</div><div className="footer-copy">TrustTech Mobile · safesnap.app@gmail.com</div></div></footer>
    </>
  );
}
